import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export function useReCaptcha() {
    const [isShowReCaptcha, setShowReCaptcha] = useState(false);
    const { shouldGetNextEntry } = useSelector(s => s.userEntryState);

    useEffect(() => {
        if (Boolean(shouldGetNextEntry)) setShowReCaptcha(true);

        return () => {
            setShowReCaptcha(false);
        };
    }, [shouldGetNextEntry]);

    return {
        isShowReCaptcha,
        setShowReCaptcha
    };
}
